import { nanoid } from "nanoid";
import { useMemo } from "react";

const useElementId = () => {
  return useMemo(() => nanoid(), []);
};

export default useElementId;
